import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Typography} from '@mui/material'
import SimpleSpinner from './SimpleSpinner'
import FileHelper from '../lib/FileHelper'
import RXRIcon from './RXRIcon'
import {makeStyles} from '@mui/styles'
import {Colors, Spacing, Typography as TypographyStyle} from '../assets/styles'

function PDFPreview({attachment, onRemove}) {
  const classes = useStyles()
  const [pdfUrl, setPdfUrl] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (attachment) {
      setIsLoading(true)
      FileHelper.Instance()
        .getFileUrlFromS3Object(attachment)
        .then(url => {
          setPdfUrl(url)
        })
        .catch(err => {
          console.error('Error loading PDF:', err)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [attachment])

  if (isLoading) {
    return <SimpleSpinner />
  }

  if (!pdfUrl) {
    return null
  }

  const fileName = attachment.displayName || attachment.key || 'document.pdf'

  return (
    <div className={classes.pdfPreview}>
      <div
        className={classes.pdfPreviewContent}
        onClick={() => window.open(pdfUrl, '_blank')}
        onMouseEnter={e => {
          e.currentTarget.parentElement.style.backgroundColor = '#f0f0f0'
          e.currentTarget.parentElement.style.borderColor = '#1976d2'
        }}
        onMouseLeave={e => {
          e.currentTarget.parentElement.style.backgroundColor = '#fafafa'
          e.currentTarget.parentElement.style.borderColor = '#d0d0d0'
        }}
      >
        <RXRIcon icon={RXRIcon.ATTACHMENT} size={RXRIcon.SIZE_LARGE} />
        <div style={{flex: 1, minWidth: 0}}>
          <Typography className={classes.fileName}>{fileName}</Typography>
          <Typography style={{fontSize: TypographyStyle.fontSizeSmall, color: Colors.rxrMediumGreyColor}}>
            Click to open in new tab
          </Typography>
        </div>
      </div>
      <div
        className={classes.deleteIcon}
        onClick={onRemove}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#ffebee'
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = 'transparent'
        }}
      >
        <RXRIcon icon={RXRIcon.TRASH} size={RXRIcon.SIZE_DEFAULT} />
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  pdfPreview: {
    border: `1px solid ${Colors.rxrGreyColor}`,
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: Spacing.spaceSmall,
    backgroundColor: Colors.nearWhiteColor,
    transition: 'all 0.2s ease',
    maxWidth: '400px',
    overflow: 'hidden',
  },

  pdfPreviewContent: {
    flex: 1,
    padding: `${Spacing.spaceSmall}px ${Spacing.spaceMedium}px`,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: Spacing.spaceSmall,
    minWidth: 0,
  },

  fileName: {
    fontWeight: 500,
    fontSize: TypographyStyle.fontSizeMediumSmall,
    marginBottom: Spacing.spaceExtraExtraSmall,
    ...TypographyStyle.ellipsis,
  },

  deleteIcon: {
    padding: `${Spacing.spaceSmall}px ${Spacing.spaceMedium}px`,
    cursor: 'pointer',
    borderLeft: `1px solid ${Colors.rxrGreyColor}`,
    display: 'flex',
    alignItems: 'center',
  },
}))

PDFPreview.propTypes = {
  attachment: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
}

export default PDFPreview
